import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/shopApply/page', data, {
    trim: true
  })
}
export function updateById (data) {
  return request.post('/business/shopApply/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/shopApply/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/shopApply/delete/batch', {
    params: {
      ids
    }
  })
}
